import { BehaviorSubject } from 'rxjs';

export const behaviorQuickNavigation$ = new BehaviorSubject({});

export const behaviorQuickNavigation = behaviorQuickNavigation$.asObservable();
